
export const Work = [
    {
        id: 1,name: "Email Outreach & Scheduling Platform",
        description:
            "Email campaign platform with scheduling, sending limits, background jobs, PostgreSQL persistence, and Dockerized services.",
        tags: [
            "TypeScript",
            "Node.js",
            "Express.js",
            "PostgreSQL",
            "Docker",
            "Redis",
            "Email Automation"
        ],
        demo: "https://drive.google.com/file/d/19Ot1ep3TovOhGRfL7hTKT92wCq5plgrZ/view?usp=sharing",
        github: "https://github.com/AnveshSrivastava/ReachInbox"
        
    },

    {
        id: 2,
        name: "Social Coordination Platform",
        description:
            "Full-stack platform for discovering places, creating groups, real-time chat, and coordinating meetups with JWT authentication.",
        tags: [
            "Java",
            "Spring Boot",
            "React",
            "MongoDB",
            "JWT",
            "REST API",
            "Vite"
        ],
        demo: "https://meetspots.netlify.app/",
        github: "https://github.com/AnveshSrivastava/Social-Coordination-Platform"
    },

    {
        id: 3,
        name: "Full-Stack E-commerce Platform",
        description:
            "E-commerce platform with Spring Boot, MongoDB, React, product management, and role-based access control.",
        tags: [
            "Java",
            "Spring Boot",
            "React",
            "MongoDB",
            "Tailwind CSS",
            "REST API"
        ],
        demo: "https://smart-cart-web.netlify.app/",
        github: "https://github.com/AnveshSrivastava/SmartCart"
    },

    {
        id: 4,
        name: "AniWave",
        description:
            "Responsive anime streaming interface built with React and TypeScript featuring multiple pages and reusable UI components.",
        tags: [
            "React",
            "TypeScript",
            "Lucide Icons"
        ],
        demo: "https://aniwavee.netlify.app/",
        github: "https://github.com/AnveshSrivastava/AniWave"
        
    },

    {
        id: 5,
        name: "AutoJobs",
        description:
            "Automated job discovery and outreach pipeline with job scoring, recruiter outreach, Google Sheets export, and email digests.",
        tags: [
            "JavaScript",
            "Node.js",
            "Express.js",
            "React",
            "SQLite",
            "REST API",
            "Automation"
        ],
        demo: "",
        github: "https://github.com/AnveshSrivastava/AutoJobs"
        
    },

    {
        id: 6,
        name: "ResumeGraph",
        description:
            "Resume versioning system for maintaining targeted resume variants across companies, roles, and technology stacks.",
        tags: [
            "System Design",
            "Backend",
            "Versioning",
            "Diffs",
            "Resume Engineering"
        ],
        demo: "",
        github: "https://github.com/AnveshSrivastava/ResumeGraph"
    },

    {
        id: 7,
        name: "TrustLayer",
        description:
            "Multi-model LLM reliability framework with parallel execution, semantic analysis, latency tracking, and failure isolation.",
        tags: [
            "Python",
            "FastAPI",
            "LLM",
            "OpenAI",
            "Gemini",
            "Claude",
            "Groq",
            "Docker"
        ],
        demo: "",
        github: "https://github.com/AnveshSrivastava/TrustLayer"
    },

    {
        id: 8,
        name: "AI Interview Prep Bot",
        description:
            "LLM-powered chatbot that simulates technical and behavioral interviews for interview preparation.",
        tags: [
            "Python",
            "FastAPI",
            "LLM",
            "AI"
        ],
        demo: "",
        github: "https://github.com/AnveshSrivastava/InterviPrep"
    },

    {
        id: 9,
        name: "SlotSwapper",
        description:
            "Schedule management platform for marking events as swappable and exchanging time slots between users.",
        tags: [
            "React",
            "Node.js",
            "Express.js",
            "PostgreSQL"
        ],
        demo: "https://slotswapperr.netlify.app/",
        github: "https://github.com/AnveshSrivastava/SlotSwapper"
    },

    {
        id: 10,
        name: "To-do List App",
        description:
            "Task management app with local storage and deadline tracking for organizing everyday tasks.",
        tags: [
            "HTML",
            "CSS",
            "JavaScript",
            "LocalStorage"
        ],
        demo: "https://anveshsrivastava.github.io/To-do-list-app/",
        github: "https://github.com/AnveshSrivastava/To-do-list-app"
    },

    {
        id: 11,
        name: "SeaMist Assignment Tracker",
        description:
            "Assignment tracker for managing academic tasks and deadlines with browser-based persistence.",
        tags: [
            "HTML",
            "CSS",
            "JavaScript",
            "LocalStorage"
        ],
        demo: "https://assignment-tracker-app.netlify.app/",
        github: "https://github.com/AnveshSrivastava/Assignment-Tracker"
    }
];
